import { RG_TYPE } from '../../types/rg-type.js';

/** types that don't need a parent */
const RgRoots = [RG_TYPE.Building, RG_TYPE.Apartment, RG_TYPE.Module, RG_TYPE.Corridor, RG_TYPE.Core];

export { RgRoots };
//# sourceMappingURL=rg-roots.js.map
